import React, { useState, useEffect } from "react";
import "./style.scss";
import { Row, Col, Modal } from "antd";
import { starIcon } from "../../utils/constants";
import ButtonComponent from "../button";
import { HomeReservationContent } from "../../pagesContent/homeReservationContent";

export default function Dining() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState("/images/ambience-fit.mp4");
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    let mounted = true;
    const checkSources = async () => {
      try {
        const mp4 = "/images/ambience-fit.mp4";
        const mov = "/images/ambience.mov";
        const res = await fetch(mp4, { method: "HEAD" });
        if (mounted && res.ok) {
          setVideoSrc(mp4);
          return;
        }
        const res2 = await fetch(mov, { method: "HEAD" });
        if (mounted && res2.ok) {
          setVideoSrc(mov);
          return;
        }
        // fallback to HomeReservationContent.video if neither found
        if (mounted) setVideoSrc(HomeReservationContent.video || mp4);
      } catch (err) {
        if (mounted) setVideoSrc(HomeReservationContent.video || "/images/ambience-fit.mp4");
      }
    };
    checkSources();
    return () => {
      mounted = false;
    };
  }, []);
  return (
    <div className="diningSection">
      <Row align={"stretch"}>
        <Col xs={24} sm={24} lg={12}>
          <div className="diningLeftside">
            <video className="ambientVideo" autoPlay muted playsInline loop>
              <source src={HomeReservationContent.video} type="video/mp4" />
              <source src="/images/ambience.mov" type="video/quicktime" />
              Your browser does not support the video tag.
            </video>
            <ButtonComponent
              text={HomeReservationContent.buttonText}
              type={"link"}
              handleOnclick={() => {
                setIsModalOpen(true);
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={24} lg={12}>
          <div className="diningRightside">
            {starIcon}
            <h1>"{HomeReservationContent.heading}"</h1>
            <p>{HomeReservationContent.text}</p>
          </div>
        </Col>
      </Row>
      <Modal
        title={<h2>{HomeReservationContent.popupTitle}</h2>}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        className="addCartPopup"
      >
        <p>{HomeReservationContent.popupText}</p>
      </Modal>
    </div>
  );
}
